module.exports = __webpack_public_path__ + "img/applications_blue.4d035688.svg";